/*
 * Silarius NVR hard-drive options (Ben, Oct 21 2026). Same model as silariussecurity.com:
 * one product per NVR + a "Hard drive" choice. The drive is its own hidden product
 * (tag nvr-hdd-option) added as a second cart line next to the NVR:
 *   NVR   {Model, "Hard drive", _hdd_tb}
 *   drive {"For NVR", _hdd_nvr: <NVR variant id>}
 * Pairing: NVR variant id + Model == "For NVR"; the drive line must be driveFor(cfgOf(NVR props)) with qty = NVR qty x per.
 * 64ch (SIL-NVRS64C4K): NVR also gets _hdd_cfg "NxS" and the drive line _hdd_per (same as silariussecurity.com).
 */
(function () {
  if (window.SilHdd) return;
  var DRIVES = {2: 50551311466599, 4: 50551311532135, 8: 50551311597671, 10: 50551311663207, 12: 50551311695975,
    16: 50551311761511, 18: 50551311827047, 22: 50551311892583, 24: 50551311925351, 36: 50551311990887, 48: 50551312056423};
  var TWO = {16: 8, 36: 18, 48: 24}; // sizes made of two identical drives
  // 8-bay 64ch NVR (Ben, Oct 21 2026, same as silariussecurity.com): 1-8 drives of one size, price = single-drive
  // price x drives; 2 drives of 8/18/24TB use the 16/36/48TB set. NVR props carry _hdd_cfg "NxS" (e.g. "7x4").
  var SET2 = {8: 16, 18: 36, 24: 48};
  var MULTI = {96: 2, 144: 3, 192: 4}; // carts made by v9 (Oct 21): N x the 48TB set
  function cfgOf(p) {
    p = p || {};
    var c = String(p._hdd_cfg || ''), tb = +p._hdd_tb || 0;
    if (/^\d+x\d+$/.test(c)) { var a = c.split('x'); return {n: +a[0], s: +a[1], tb: +a[0] * +a[1]}; }
    return tb ? {tb: tb} : null;
  }
  function driveFor(cfg) {
    if (!cfg) return null;
    if (cfg.n) return cfg.n === 2 && SET2[cfg.s] ? {id: DRIVES[SET2[cfg.s]], per: 1} : {id: DRIVES[cfg.s], per: cfg.n};
    if (MULTI[cfg.tb]) return {id: DRIVES[48], per: MULTI[cfg.tb]};
    return DRIVES[cfg.tb] ? {id: DRIVES[cfg.tb], per: 1} : null;
  }
  var NVRS = {
    40310784327783: 'silarius-pro-series-sil-nvr4chpoe-9ch-total-4-channels-4k-poe-nvr-gigabit-nvr-no-hdd',
    39532559073383: 'silarius-pro-series-sil-nvr9ch-4k-nvr-9ch-no-hdd',
    39956749385831: 'silarius-pro-series-sil-nvr8chwifi-8ch-total-4k-nvr-gigabit-nvr-no-hdd',
    32598685974631: 'silarius-pro-series-silnvr4k16-4k-nvr-16ch-8ch-poe-no-hdd',
    40310818406503: 'silarius-pro-series-sil-nvr16chpoe-25ch-total-16-channels-4k-poe-nvr-gigabit-nvr-no-hdd',
    39532568772711: 'silarius-pro-series-sil-xvr4ch-xvr-4ch-bnc-no-hdd',
    32980239319143: 'silarius-sil-4chnvrwifi8mpkit-4ch-8mp-wifi-kit-4k',
    39765116125287: 'silarius-pro-series-sil-nvrai16-36-channels-4k-ai-nvr-gigabit-12mp-face-recognition-face-comparison-nvr-no-hdd',
    50333531373671: 'silarius-sil-nvrs32c4k-32ch-2hdd-4k-nvr',
    50333533995111: 'silarius-sil-nvrs64c4k-64ch-2u-8hdd-4k-nvr'
  };
  var TB_OF = {};
  Object.keys(DRIVES).forEach(function (tb) { TB_OF[DRIVES[tb]] = tb; });

  function hddLabel(tb, n, sz) {
    tb = +tb;
    if (n) return tb + 'TB (' + n + ' × ' + sz + 'TB)';
    if (MULTI[tb]) return tb + 'TB (' + MULTI[tb] * 2 + ' × 24TB)';
    return TWO[tb] ? tb + 'TB (2 × ' + TWO[tb] + 'TB)' : tb + 'TB (1 × ' + tb + 'TB)';
  }
  function model(sku, tb) { return +tb ? sku + tb : sku; }
  /* The two cart lines for an NVR with a drive (used by the product page, kit builder and planners). */
  function lines(nvrVariantId, baseSku, tb, qty, n, sz) {
    qty = qty || 1;
    var cfg = n ? {n: +n, s: +sz, tb: +n * +sz} : {tb: +tb || 0}, d = cfg.tb && driveFor(cfg);
    if (!d || !d.id) return [{id: +nvrVariantId, quantity: qty}];
    var m = model(baseSku, cfg.tb), np = {'Model': m, 'Hard drive': hddLabel(cfg.tb, cfg.n, cfg.s), '_hdd_tb': String(cfg.tb)}, dp = {'For NVR': m, '_hdd_nvr': String(nvrVariantId)};
    if (cfg.n) { np._hdd_cfg = cfg.n + 'x' + cfg.s; dp._hdd_per = String(d.per); }
    return [{id: +nvrVariantId, quantity: qty, properties: np}, {id: d.id, quantity: qty * d.per, properties: dp}];
  }

  var origFetch = window.fetch.bind(window);
  var JSONH = {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'};
  function post(url, body) {
    return origFetch(url, {method: 'POST', credentials: 'same-origin', headers: JSONH, body: JSON.stringify(body)})
      .then(function (r) { return r.json(); });
  }
  function getCart() { return origFetch('/cart.js', {credentials: 'same-origin', headers: {'Accept': 'application/json'}}).then(function (r) { return r.json(); }); }

  /* What has to change so every drive line sits next to exactly one NVR (drive qty = NVR qty x per(size)). */
  function plan(cart) {
    var ops = [];
    var used = {};
    var items = cart.items || [];
    items.forEach(function (d) {
      var tb = TB_OF[d.variant_id];
      if (!tb) return;
      var forId = d.properties && d.properties._hdd_nvr, forM = d.properties && d.properties['For NVR'];
      var n = null;
      for (var i = 0; i < items.length; i++) {
        var x = items[i], xp = x.properties || {};
        var xd = xp._hdd_tb ? driveFor(cfgOf(xp)) : null;
        if (!used[x.key] && forId && String(x.variant_id) === String(forId) && xd && String(xd.id) === String(d.variant_id) && (!forM || !xp.Model || xp.Model === forM)) { n = x; break; }
      }
      if (!n) { ops.push({type: 'change', id: d.key, quantity: 0}); return; }
      used[n.key] = 1;
      var want = n.quantity * driveFor(cfgOf(n.properties)).per;
      if (d.quantity !== want) ops.push({type: 'change', id: d.key, quantity: want});
    });
    items.forEach(function (n) {
      if (n.properties && n.properties._hdd_tb && !used[n.key]) ops.push({type: 'strip', id: n.key, variant: n.variant_id, quantity: n.quantity});
    });
    return ops;
  }
  function run(ops) {
    var chain = Promise.resolve();
    // removals / quantity fixes first (keys stay stable), strips last
    ops.filter(function (o) { return o.type === 'change'; }).forEach(function (o) {
      chain = chain.then(function () { return post('/cart/change.js', {id: o.id, quantity: o.quantity}); });
    });
    ops.filter(function (o) { return o.type === 'strip'; }).forEach(function (o) {
      // Shopify keeps blank property keys, so an NVR loses its drive properties by being re-added plain
      chain = chain.then(function () { return post('/cart/change.js', {id: o.id, quantity: 0}); })
        .then(function () { return post('/cart/add.js', {items: [{id: o.variant, quantity: o.quantity}]}); });
    });
    return chain.then(getCart);
  }
  var syncing = false;
  function sync(cart) {
    var ops = plan(cart);
    if (!ops.length) return Promise.resolve(null);
    syncing = true;
    return run(ops).then(function (c) { syncing = false; return c; }, function (e) { syncing = false; throw e; });
  }
  function refresh() {
    if (document.body && /template-cart/.test(document.body.className)) { window.location.reload(); return; }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
  }

  /* ---------- product page picker ---------- */
  var picker = null;
  function money(cents, trim) {
    var s = (Number(cents || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (trim) s = s.replace(/\.00$/, '');
    return '$' + s;
  }
  function titleFor(title, sku, tb) {
    if (!+tb) return title;
    var t = title.split(sku).join(model(sku, tb));
    return /\bno\s+hdd\b/i.test(t) ? t.replace(/\bno\s+hdd\b/i, tb + 'TB HDD') : t + ', ' + tb + 'TB HDD';
  }
  function setText(sel, txt) {
    document.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; });
  }
  function pick(btn, fromUser) {
    var root = picker.root;
    root.querySelectorAll('.SilHdd__Opt').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var tb = +btn.getAttribute('data-tb') || 0;
    var dp = +btn.getAttribute('data-p') || 0;
    picker.tb = tb; picker.n = 0; picker.s = 0;
    show(tb, dp, fromUser, tb ? (MULTI[tb] ? MULTI[tb] * 2 + ' × 24TB drives, all the same model, as recommended.' : TWO[tb] ? '2 × ' + TWO[tb] + 'TB drives, both the same model, as recommended.' : 'One ' + tb + 'TB drive.') : '', tb);
  }
  /* 64ch: number of drives x size of each drive */
  function pick8(fromUser) {
    var root = picker.root, n = picker.n, sz = picker.s;
    root.querySelectorAll('[data-n]').forEach(function (b) { var on = +b.getAttribute('data-n') === n; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    root.querySelectorAll('[data-s]').forEach(function (b) {
      var on = +b.getAttribute('data-s') === sz, p1 = +b.getAttribute('data-p') || 0, p2 = +b.getAttribute('data-p2') || 0;
      b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); b.disabled = !n;
      var sm = b.querySelector('small'); if (sm) sm.textContent = n ? '+' + money(n === 2 && p2 ? p2 : p1 * n, true) : money(p1, true) + ' each';
    });
    var row = root.querySelector('[data-sil-hdd-size]'); if (row) row.hidden = !n;
    var sb = root.querySelector('[data-s="' + sz + '"]'), p1 = sb ? +sb.getAttribute('data-p') || 0 : 0, p2 = sb ? +sb.getAttribute('data-p2') || 0 : 0;
    var tb = n * sz, dp = n ? (n === 2 && p2 ? p2 : p1 * n) : 0;
    picker.tb = tb;
    show(tb, dp, fromUser, !n ? '' : n === 1 ? 'One ' + sz + 'TB drive.' : n + ' × ' + sz + 'TB drives, all the same model, as recommended.', n ? n + 'x' + sz : '');
  }
  function show(tb, dp, fromUser, noteTxt, q) {
    var root = picker.root;
    var m = model(picker.sku, tb);
    var total = picker.price + dp;
    setText('.ProductMeta__Title, .silp-sticky__t', titleFor(picker.title, picker.sku, tb));
    setText('[data-sil-sku]', m);
    document.querySelectorAll('.silp-grid2 dd').forEach(function (dd) {
      var dt = dd.previousElementSibling;
      if (dt && /^\s*model\s*$/i.test(dt.textContent)) dd.textContent = m;
    });
    setText('.ProductMeta__Price, .silp-sticky__p', money(total));
    var btnPrice = document.querySelector('.ProductForm__AddToCart span:last-child');
    if (btnPrice) btnPrice.textContent = money(total);
    var br = root.querySelector('[data-sil-hdd-break]');
    var multi = (picker.n || 0) > 1 || MULTI[tb] || TWO[tb];
    if (br) br.textContent = tb ? money(total) + ' — NVR ' + money(picker.price) + ' + ' + tb + 'TB hard drive' + (multi ? 's ' : ' ') + money(dp, true) : '';
    var note = root.querySelector('[data-sil-hdd-note]');
    if (note) note.textContent = (tb ? noteTxt : 'No hard drive included.') + ' Model ' + m + '.';
    if (fromUser && window.history && history.replaceState) {
      var u = new URL(window.location.href);
      if (tb) u.searchParams.set('hdd', q); else u.searchParams.delete('hdd');
      history.replaceState(history.state, '', u.toString());
    }
  }
  function initPicker() {
    var root = document.querySelector('[data-sil-hdd]');
    if (!root || root.__silHdd) return;
    root.__silHdd = 1;
    picker = {root: root, nvr: root.getAttribute('data-nvr'), sku: root.getAttribute('data-sku'),
      price: +root.getAttribute('data-price'), title: root.getAttribute('data-title'), tb: 0, n: 0, s: 0};
    var q = String(new URLSearchParams(window.location.search).get('hdd') || '');
    if (root.getAttribute('data-bays') === '8') {
      var sizes = [].map.call(root.querySelectorAll('[data-s]'), function (b) { return +b.getAttribute('data-s'); });
      picker.n = 0; picker.s = sizes.indexOf(24) > -1 ? 24 : sizes[sizes.length - 1] || 0;
      var mq = q.match(/^(\d+)x(\d+)$/), tq = parseInt(q, 10);
      if (mq && +mq[1] >= 1 && +mq[1] <= 8 && sizes.indexOf(+mq[2]) > -1) { picker.n = +mq[1]; picker.s = +mq[2]; }
      else if (tq) sizes.slice().reverse().some(function (z) { if (tq % z === 0 && tq / z <= 8) { picker.n = tq / z; picker.s = z; return true; } });
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-n],[data-s]'); if (!b || b.disabled) return;
        if (b.hasAttribute('data-n')) picker.n = +b.getAttribute('data-n'); else picker.s = +b.getAttribute('data-s');
        pick8(true);
      });
      pick8(false);
      return;
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.SilHdd__Opt');
      if (b) pick(b, true);
    });
    var want = parseInt(q, 10);
    var start = want && root.querySelector('.SilHdd__Opt[data-tb="' + want + '"]');
    pick(start || root.querySelector('.SilHdd__Opt'), false);
  }

  /* ---------- fetch hooks: add the pair from the product form, keep the pair in step on changes ---------- */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (picker && picker.tb && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
      try {
        var b = JSON.parse(init.body);
        if (b && !b.items && String(b.id) === String(picker.nvr)) {
          var q = parseInt(b.quantity, 10) || 1;
          init = Object.assign({}, init, {body: JSON.stringify({items: lines(picker.nvr, picker.sku, picker.tb, q, picker.n, picker.s)})});
          return origFetch(input, init);
        }
      } catch (e) {}
    }
    var p = origFetch(input, init);
    if (!syncing && /\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) {
      return p.then(function (r) {
        if (!r.ok) return r;
        return r.clone().json().then(function (cart) {
          return sync(cart).then(function (c) {
            return c ? new Response(JSON.stringify(c), {status: 200, headers: {'Content-Type': 'application/json'}}) : r;
          });
        }).catch(function () { return r; });
      });
    }
    return p;
  };

  document.addEventListener('click', function (e) {
    // "Remove drive" in the cart page / drawer: drop the drive and give the NVR back its No HDD state
    var rm = e.target.closest && e.target.closest('[data-sil-hdd-remove]');
    if (rm) {
      e.preventDefault();
      e.stopPropagation();
      rm.textContent = 'Removing…';
      post('/cart/change.js', {id: rm.getAttribute('data-sil-hdd-remove'), quantity: 0})
        .then(getCart).then(sync).then(refresh, refresh);
      return;
    }
    // Quick add on a collection card: these NVRs need a drive choice, so open the product page
    var qa = e.target.closest && e.target.closest('[data-sil-qa]');
    if (qa && NVRS[qa.getAttribute('data-sil-qa')]) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = '/products/' + NVRS[qa.getAttribute('data-sil-qa')];
    }
  }, true);

  // Cart page: typing a new NVR quantity moves its drive's hidden updates[] slot with it
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('QuantitySelector__CurrentQuantity')) return;
    var d = document.querySelector('[data-sil-hdd-pair="' + t.getAttribute('data-line') + '"]');
    if (d) d.value = (parseInt(t.value, 10) || 0) * (+d.getAttribute('data-sil-hdd-per') || 1);
  }, true);

  function start() {
    initPicker();
    // Anything that changed the cart outside these hooks (page reload with ?quantity=, another app): fix once on load
    if (!document.querySelector('[data-sil-hdd-has]')) return;
    var k = 'silHddFix';
    getCart().then(sync).then(function (c) {
      if (!c) { try { sessionStorage.removeItem(k); } catch (e) {} return; }
      try { if (sessionStorage.getItem(k) === location.pathname) return; sessionStorage.setItem(k, location.pathname); } catch (e) {}
      refresh();
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.SilHdd = {drives: DRIVES, two: TWO, multi: MULTI, set2: SET2, cfgOf: cfgOf, driveFor: driveFor, nvrs: NVRS, lines: lines, label: hddLabel, model: model, plan: plan, sync: sync};
})();
